import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPage } from '../lib/microcms';

const Page = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    getPage(slug)
      .then((data) => {
        setPage(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <div className="gc-page">
        <div className="gc-page__container">
          <p className="gc-page__loading">読み込み中...</p>
        </div>
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="gc-page">
        <div className="gc-page__container">
          <h1 className="gc-page__title">ページが見つかりません</h1>
          <Link to="/" className="gc-page__back">トップページへ戻る</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="gc-page">
      <div className="gc-page__container">
        <h1 className="gc-page__title">{page.title}</h1>
        <div
          className="gc-page__body"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
        <Link to="/" className="gc-page__back">トップページへ戻る</Link>
      </div>
    </div>
  );
};

export default Page;
